import { useState } from "react";
import {
  RiMailLine,
  RiMessage2Line,
  RiWhatsappLine,
  RiSendPlaneLine,
  RiSettings4Line,
  RiRobot2Line,
  RiEyeLine,
  RiDragMove2Line,
} from "react-icons/ri";
import ChannelConfig from "../components/messaging/ChannelConfig";
import AIResponseGenerator from "../components/messaging/AIResponseGenerator";
import DynamicVariables from "../components/messaging/DynamicVariables";
import MessagePreview from "../components/messaging/MessagePreview";
import EmailEditor from "../components/messaging/EmailEditor";

const BulkMessaging = () => {
  const [messageType, setMessageType] = useState("email");
  const [schedule, setSchedule] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedList, setSelectedList] = useState("");
  const [showConfig, setShowConfig] = useState(false);
  const [showAI, setShowAI] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({
    first_name: "John",
    last_name: "Doe",
    company_name: "Acme Corp",
    custom_offer: "SUMMER2023",
    total_amount: "$199.99",
    order_date: "2023-07-15",
  });
  const [editorView, setEditorView] = useState("simple");

  const channels = [
    { id: "email", name: "Email", icon: RiMailLine },
    { id: "sms", name: "SMS", icon: RiMessage2Line },
    { id: "whatsapp", name: "WhatsApp", icon: RiWhatsappLine },
  ];

  const handleSend = () => {
    // Implement send functionality
    console.log("Sending message:", {
      messageType,
      message,
      selectedList,
      schedule,
    });
  };

  const handleAIResponse = (selectedMessage) => {
    setMessage(selectedMessage);
    setShowAI(false);
  };

  const handleInsertVariable = (variable) => {
    setMessage(message + " " + variable);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-secondary-900">
          Bulk Messaging
        </h1>
        <div className="flex space-x-3">
          {(messageType === "sms" || messageType === "whatsapp") && (
            <button
              className="btn btn-secondary flex items-center"
              onClick={() => setShowAI(!showAI)}
            >
              <RiRobot2Line className="w-5 h-5 mr-2" />
              AI Suggestions
            </button>
          )}
          <button
            className="btn btn-secondary flex items-center"
            onClick={() => setShowConfig(!showConfig)}
          >
            <RiSettings4Line className="w-5 h-5 mr-2" />
            Channel Settings
          </button>
        </div>
      </div>

      {showConfig ? (
        <ChannelConfig />
      ) : (
        <div className="space-y-6">
          <div className="card">
            <div className="flex space-x-4 mb-6">
              {channels.map((channel) => (
                <button
                  key={channel.id}
                  className={`flex items-center px-4 py-2 rounded-lg ${
                    messageType === channel.id
                      ? "bg-primary-500 text-white"
                      : "bg-secondary-100 text-secondary-700 hover:bg-secondary-200"
                  }`}
                  onClick={() => {
                    setMessageType(channel.id);
                    setShowAI(false);
                  }}
                >
                  <channel.icon className="w-5 h-5 mr-2" />
                  {channel.name}
                </button>
              ))}
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Recipients
                </label>
                <select
                  className="w-full p-2 border rounded-lg"
                  value={selectedList}
                  onChange={(e) => setSelectedList(e.target.value)}
                >
                  <option value="">Select Recipient List</option>
                  <option value="all">All Customers</option>
                  <option value="new">New Subscribers</option>
                </select>
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="block text-sm font-medium">Message</label>
                  <div className="flex items-center space-x-3">
                    {messageType === "email" && (
                      <div className="flex items-center space-x-2 mr-4 bg-secondary-100 rounded-lg p-1">
                        <button
                          className={`px-3 py-1 rounded ${
                            editorView === "simple"
                              ? "bg-white shadow text-primary-500"
                              : "text-secondary-600"
                          }`}
                          onClick={() => setEditorView("simple")}
                        >
                          Simple
                        </button>
                        <button
                          className={`flex items-center px-3 py-1 rounded ${
                            editorView === "advanced"
                              ? "bg-white shadow text-primary-500"
                              : "text-secondary-600"
                          }`}
                          onClick={() => setEditorView("advanced")}
                        >
                          <RiDragMove2Line className="w-4 h-4 mr-2" />
                          Drag & Drop
                        </button>
                      </div>
                    )}
                    <DynamicVariables
                      variables={[]}
                      onInsert={handleInsertVariable}
                    />
                    <button
                      className="btn btn-secondary flex items-center"
                      onClick={() => setShowPreview(!showPreview)}
                    >
                      <RiEyeLine className="w-5 h-5 mr-2" />
                      Preview
                    </button>
                  </div>
                </div>
                {messageType === "email" && editorView === "advanced" ? (
                  <EmailEditor
                    value={message}
                    onChange={setMessage}
                    variables={previewData}
                  />
                ) : (
                  <textarea
                    className="input-field h-32"
                    placeholder="Enter your message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                )}
                {showPreview && (
                  <div className="mt-4 border-t border-secondary-200 pt-4">
                    <MessagePreview
                      message={message}
                      type={messageType}
                      variables={previewData}
                    />
                  </div>
                )}
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="schedule"
                  checked={schedule}
                  onChange={(e) => setSchedule(e.target.checked)}
                  className="mr-2"
                />
                <label htmlFor="schedule">Schedule for later</label>
              </div>

              {schedule && (
                <input
                  type="datetime-local"
                  className="w-full p-2 border rounded-lg"
                />
              )}

              <div className="flex justify-end">
                <button
                  className="btn btn-primary flex items-center"
                  onClick={handleSend}
                >
                  <RiSendPlaneLine className="w-5 h-5 mr-2" />
                  {schedule ? "Schedule Message" : "Send Now"}
                </button>
              </div>
            </div>
          </div>

          {showAI && (messageType === "sms" || messageType === "whatsapp") && (
            <div className="card bg-gradient-to-br from-white to-primary-50/30">
              <AIResponseGenerator
                context={{
                  channel: messageType,
                  recipients: selectedList,
                }}
                onSelect={handleAIResponse}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BulkMessaging;
